import { readController } from 'fc-controller'

import {
  URL,
  MODEL,
  TREE,
  BRANCH,
} from './constants'

// Selectors
import token$ from 'fc-auth/src/selectors/token'

import { composeFetchSaga } from 'fc-fetch-worker'

// Controller
export default readController({
  url: URL,
  model: MODEL,
  tree: TREE,
  branch: BRANCH,
  token$,
  watch: false,
  initialize: function initialize (controller) {
    let worker = null

    const terminate = function terminate () {
      if (worker) {
        console.warn('Terminating Crops Worker')
        worker.terminate()
        worker = null
      }
    }

    return new Promise((resolve) => {
      terminate()

      console.warn('Initializing Crops Worker')
      const CropWorker = require('worker-loader?name=[hash].crops.js!./worker.js')
      const worker = new CropWorker()

      resolve({
        terminate,
        handleFetch: composeFetchSaga({
          getWorker: function () {
            return worker
          },
        }),
      })
    })
  },
})
